import script from "./Yoube.vue?vue&type=script&setup=true&lang=js"
export * from "./Yoube.vue?vue&type=script&setup=true&lang=js"

import "./Yoube.vue?vue&type=style&index=0&id=5da7934b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5da7934b"]])

export default __exports__